import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { importRolesApi, RolesCollection } from "@tKgpco/Services/SecurityRolesService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type Parameters = any & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, RolesCollection>;

export const PopulateApiParameters: HandlerType = props => {
    const { file } = props.parameter;
    props.apiParameter = {
        file,
    };
};

export const ImportRoles: HandlerType = async props => {
    try {
        await importRolesApi(props.apiParameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccess: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameters, ImportRoles, ExecuteOnSuccess];

const importRoles = createHandlerChainRunner(chain, "importRoles");
export default importRoles;
